export async function fetchLsSettings({ token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getLsSettings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({}),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to fetch settings");
  }

  return resp.json();
}
